export default {
  title: 'パスワードを忘れた場合',
  rememberText: 'パスワードを思い出しましたか？',
  rememberLinkText: '今すぐログイン',
  sendemail: {
    labelText: 'あなたのメールにリンクを送信しました',
    remindText:
      'アクティベーションメールがあなたのメールに送信されました。メールの有効期限は24時間です。メールにログインし、リンクをクリックしてアカウントをアクティベートしてください。',
    checkButtonText: 'メールを確認',
    homeButtonText: 'ホームに戻る',
  },
  form: {
    mail: {
      placeHolder: 'メールアドレスを入力してください',
      required: 'メールアドレスは空白にできません',
      formatVeryfy: '有効なメールアドレスを入力してください',
    },
    code: {
      required: '確認コードは空白にできません',
    },
    submitText: 'パスワードをリセット',
  },
}
